/* eslint-disable no-shadow */
import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { getFormValues } from 'redux-form'
import NotificationSystem from 'rc-notification'

import { FullWideNotification } from 'Shared/components/Notification'
import { resetPassword } from 'Redux/actions/auth'
import logo from 'Shared/img/logo.png'

import ForgotPasswordForm from './components/ResetPasswordForm'
import {
  locationEvent,
  pageInfo,
  pageViewEvent,
} from '../../Helpers/tagManager'

let notification = null

const showNotification = (message, color) => {
  notification.notice({
    content: <FullWideNotification color={color} message={message} />,
    position: 'full',
    duration: 3,
    closable: true,
    style: { top: 0, left: 0 },
    className: `ltr-support`,
  })
}

const ResetPassword = ({ formStates, resetPassword }) => {
  const { t } = useTranslation()

  useEffect(() => {
    pageViewEvent(null, pageInfo.resetPassword)
    locationEvent()
  }, [])

  const { uuid } = useParams()

  const handleSubmit = () => {
    const { password } = formStates
    NotificationSystem.newInstance(
      { style: { top: 65 } },
      // eslint-disable-next-line no-return-assign
      n => (notification = n)
    )
    resetPassword(password, uuid, error => {
      if (!error) {
        showNotification(t('forgotPasswordPage.passwordChanged'), 'success')
      } else {
        showNotification(t('forgotPasswordPage.linkExpired'), 'danger')
      }
    })
    // eslint-disable-next-line no-param-reassign
    formStates.password = ''
    // eslint-disable-next-line no-param-reassign
    formStates.confirm = ''
  }

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="login-logo">
          <img alt="logo" src={logo} />
        </div>
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              {t('forgotPasswordPage.resetPassword')}
            </h3>
          </div>
          <ForgotPasswordForm onSubmit={handleSubmit} />
          <div className="text__center">
            <Link to="/">{t('forgotPasswordPage.backToLogin')}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  formStates: getFormValues('reset_password_form')(state),
})

const actions = {
  resetPassword,
}

export default compose(connect(mapStateToProps, actions))(ResetPassword)
